import { Modal, Spin, Row, Col } from "antd";
import { useState } from "react";
import { get } from "../../../../utils/fetch";
import { URL_PROVEEDOR_API } from "../../../../constants/url";
import { MapaPasarLatLng } from "../../../../components/mapaGoogle/MapaPasarLatLng";

export const ConsultarSanMarcos = ({ asistenciaID, nombreComercial }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [servicioData, setServicioData] = useState(null);
  const [loading, setLoading] = useState(false);

  const isSanMarcos = nombreComercial?.toUpperCase().includes("SAN MARCOS");

  const handleConsultar = async () => {
    setModalVisible(true);
    setLoading(true);
    const result = await get(`${URL_PROVEEDOR_API}/getServiciosSanMarcos/${asistenciaID}`);
    setServicioData(result.code === 0 ? result.data : { error: result.error || "Error al consultar el servicio" });
    setLoading(false);
  };

  if (!isSanMarcos) return null;

  return (
    <>
      <a onClick={handleConsultar}>
        Consultar estatus
      </a>
      <Modal
        title="Estatus de Servicio - San Marcos"
        open={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          setServicioData(null);
        }}
        footer={null}
        width={600}
      >
        {loading ? (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <Spin size="large" />
            <div style={{ marginTop: "20px" }}>Consultando servicio...</div>
          </div>
        ) : servicioData ? (
          servicioData.error ? (
            <div style={{ textAlign: "center", padding: "20px", color: "red" }}>
              {servicioData.error}
            </div>
          ) : (
            <div>
              <Row>
                <Col span={12}>
                  <strong>ID:</strong> {servicioData.id || "-"}
                </Col>
                <Col span={12}>
                  <strong>Ex1:</strong> {servicioData.ex1 || "-"}
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col span={12}>
                  <strong>Ex2:</strong> {servicioData.ex2 || "-"}
                </Col>
                <Col span={12}>
                  <strong>Grúa:</strong> {servicioData.grua || "-"}
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col span={12}>
                  <strong>Operador:</strong> {servicioData.operador || "-"}
                </Col>
                <Col span={12}>
                  <strong>Tiempo:</strong> {servicioData.tiempo || "-"}
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col span={12}>
                  <strong>Latitud:</strong> {servicioData.lat || "-"}
                </Col>
                <Col span={12}>
                  <strong>Longitud:</strong> {servicioData.lon || "-"}
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col span={12}>
                  <strong>Término:</strong> {servicioData.termino || "-"}
                </Col>
                <Col span={12}>
                  <strong>Status:</strong> {servicioData.status || "-"}
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col span={12}>
                  <strong>Aseguradora:</strong> {servicioData.aseguradora || "-"}
                </Col>
              </Row>

              {servicioData.lat && servicioData.lon && (
                <div style={{ marginTop: 20 }}>
                  <strong>Ubicación:</strong>
                  <MapaPasarLatLng lat={servicioData.lat} lon={servicioData.lon} />
                </div>
              )}
            </div>
          )
        ) : null}
      </Modal>
    </>
  );
};